import React from "react";
import styles from "./CustomerContract.module.scss";
import Grid from "@material-ui/core/Grid";
import DownloadButton from "../../../imgs/download.svg";
import UploadButton from "../../../imgs/upload.svg";
import HasPermissionTo from "../../../common/HasPermissionTo";
import { withTranslation } from "react-i18next";

const AgentContractRow = (props) => {
  return (
    <div className={styles.borderBottom} key={props.key}>
      <Grid container key={props.key} className="pagePaddingLeft">
        <Grid className={`${styles.gridRow} ${styles.dealerName}`} item xs={4}>
          {props.contract.market + " | " + props.contract.name}
        </Grid>
        <Grid
          className={`${styles.gridRowCentered} ${styles.greyText}`}
          item
          xs={4}
        >
          {props.contract.contract ? props.contract.dateUploaded || "-" : "-"}
        </Grid>
        {/*<Grid*/}
        {/*  className={`${styles.gridRowCentered} ${styles.greyText}`}*/}
        {/*  item*/}
        {/*  xs={2}*/}
        {/*>*/}
        {/*  {props.contract.contract*/}
        {/*    ? (props.contract.uploadedBy &&*/}
        {/*        props.contract.uploadedBy.toUpperCase()) ||*/}
        {/*      "-"*/}
        {/*    : "-"}*/}
        {/*</Grid>*/}
        <Grid className={styles.gridRowRight} item xs={4}>
          {props.contract.contract ? (
            <div className={styles.downloadDiv}>
              <div className={styles.download}>
                <span
                  onClick={() => props.handleContractDownload(props.contract)}
                  className={styles.updateText}
                >
                  {props.t("CustomerContract.download")}
                </span>
                <img
                  alt="Download"
                  onClick={() => props.handleContractDownload(props.contract)}
                  src={DownloadButton}
                />
                <HasPermissionTo
                  perform={["customerContract:write"]}
                  permissions={props.user.permissions.rolePermissions}
                  condition={true}
                  render={() => {
                    return (
                      <a
                        className={styles.updateLink}
                        onClick={() =>
                          props.updateShowDialogForADealer(props.contract)
                        }
                      >
                        {props.t("CustomerContract.update")}
                      </a>
                    );
                  }}
                />
              </div>
            </div>
          ) : (
            <HasPermissionTo
              perform={["customerContract:write"]}
              permissions={props.user.permissions.rolePermissions}
              render={() => {
                return (
                  <div className={styles.uploadFlexBox}>
                    <div className={styles.pointer}>
                      <div
                        onClick={() =>
                          props.updateShowDialogForADealer(props.contract)
                        }
                      >
                        <span className={styles.updateText}>
                          {props.t("CustomerContract.upload")}
                        </span>
                        <img alt="Upload" src={UploadButton} />
                      </div>
                    </div>
                  </div>
                );
              }}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default withTranslation("emp")(AgentContractRow);
